import { Component,EventEmitter,ViewChild,Output,ElementRef} from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { DatePipe } from "@angular/common";
import { HttpErrorResponse } from '@angular/common/http';
import { MessagesGeneral,MessagesTitles,MessagesStatus} from '../../../models/messages';
import { ReportesService } from '../../../services/reportes/reportes.service';
import * as XLSX from 'xlsx';
import Swal from "sweetalert2";

@Component({
  selector: 'app-detalle-rep-concil',
  templateUrl: './detalle-rep-concil.component.html',
  styleUrls: ['./detalle-rep-concil.component.scss'],
  providers:[DatePipe,MessagesTitles,MessagesGeneral,MessagesStatus]
})
export class DetalleRepConcilComponent {

  @Output() cerrarPopDetalleConciliacion : EventEmitter<boolean> = new EventEmitter();

  idDesembolso:any;
  dataReporte:any = [] ;
  isLoading:boolean = true;
  dataSource:any;

  @ViewChild('TABLE',{static: true}) table: ElementRef;
  displayedColumns: string[] =['Adelanto_importe','Interes_importe','Comision_importe','IGV_importe','Factoring_Importe','Factoring_SUNAT_importe']

  constructor(private reporteService:ReportesService,
    private msgTitulos : MessagesTitles,
    private msgStatus:MessagesStatus) {
      this.idDesembolso = this.reporteService.idDesembolso;
      this.obtenerDetalleConciliacion();
     }

  ExportTOExcel(){
    const ws: XLSX.WorkSheet=XLSX.utils.json_to_sheet(this.dataReporte);  
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    
    /* save to file */
    let fecha = new Date();
    XLSX.writeFile(wb, 'Detalle_Conciliacion'+fecha+'.xlsx'); 
  }

obtenerDetalleConciliacion(){
  this.reporteService.FiltrarDetallePlanilla(this.idDesembolso)
  .subscribe(res=>{  
      this.dataReporte = res;
      this.isLoading = false ;
      this.dataSource = new MatTableDataSource(this.dataReporte)
  }, (err: HttpErrorResponse)=> {
    if (err.error instanceof ErrorEvent) {
      console.error("Error Event"); 
  } else {
      this.msgStatus.getMessage(err.status);            
  }
  Swal.fire({
    title: this.msgTitulos.Error,
    text: "LISTA DETALLE CONCILIACION. NO OBTENIDO. "+this.msgStatus.message,
    type: "error",
    allowOutsideClick: false
  });
  })
}

CerrarPopUp(){
  this.cerrarPopDetalleConciliacion.emit();
}


}
